<template>
  <div class="p-config-edit-project">
    <div class="flex">
      <div class="title">
        <p>
          サイト名
        </p>
      </div>
      <div class="form c-alertPos">
        <Input
          name="projectName"
          v-model="params.projectName"
          placeholder="例: 自社メディアサイト"
          :class="{ alert: isEdited.projectName && error.projectName }"
        />
        <Alert v-if="isEdited.projectName && error.projectName">
          {{ error.projectName }}
        </Alert>
        <Alert v-else-if="errorResponse">
          {{ errorResponse }}
        </Alert>
      </div>
      <div class="btnArea">
        <div class="form-auto">
          <Button
            variant="main"
            size="w230"
            fsize="f16"
            :disabled="!isEdited.projectName || isError || isProcessing"
            :class="{ 'is-loading': isProcessing }"
            @click="submit"
          >
            変更する
          </Button>
        </div>
      </div>
    </div>
    <EditPublishedDate :project="project" />
    <table class="c-table l-mt-5">
      <tbody>
        <template v-if="project.gaAccountId">
          <tr>
            <th rowspan="4" class="bg">Google Analytics(UA)</th>
            <td>アカウントID</td>
            <td width="50%">{{ project.gaAccountId }}</td>
          </tr>
          <tr>
            <td>プロパティID</td>
            <td>{{ project.gaPropertyId }}</td>
          </tr>
          <tr>
            <td>ビューID</td>
            <td>{{ project.gaViewId }}</td>
          </tr>
          <tr>
            <td>ビュー名</td>
            <td>{{ project.gaViewName }}</td>
          </tr>
        </template>
        <template v-if="project.ga4AccountId">
          <tr>
            <th rowspan="3" class="bg">Google Analytics(GA4)</th>
            <td>アカウントID</td>
            <td width="50%">
              {{ project.ga4AccountId | truncateRegExp(/accounts\//) }}
            </td>
          </tr>
          <tr>
            <td>プロパティID</td>
            <td>
              {{ project.ga4PropertyId | truncateRegExp(/properties\//) }}
            </td>
          </tr>
          <tr>
            <td>データストリームID</td>
            <td>
              {{
                project.ga4DataStreamId | truncateRegExp(/.*\/dataStreams\//)
              }}
            </td>
          </tr>
        </template>
        <tr>
          <th class="bg">Search Console</th>
          <td>サイトURL</td>
          <td>{{ project.siteUrl }}</td>
        </tr>
      </tbody>
    </table>
    <ButtonAuthGA4
      v-if="isVisibleGA4Button"
      :project="project"
      :disabled="isDisabledGA4Button"
    />
    <Note>
      <p>
        Google Analytics・Search Consoleの変更を行う場合は、<span
          class="c-text--accent"
          >再度、サイト登録</span
        >に進んでください。
      </p>
    </Note>
  </div>
</template>
<script>
import Alert from '@/components/Alert';
import Input from '@/components/Input';
import Button from '@/components/Button';
import ButtonAuthGA4 from '@/components/config/ButtonAuthGA4';
import EditPublishedDate from '@/components/edit/EditPublishedDate';
import Note from '@/components/Note';
import apiProjects from '@/api/projects';
import utils from '@/utils';
import Validation from '@/validation';

export default {
  props: ['project', 'isLoading'],
  components: {
    Alert,
    Button,
    ButtonAuthGA4,
    EditPublishedDate,
    Input,
    Note
  },
  data() {
    return {
      error: {
        projectName: ''
      },
      errorResponse: '',
      params: {
        projectName: this.project.name
      },
      isEdited: {
        projectName: false
      },
      isError: false,
      isProcessing: false
    };
  },
  computed: {
    isDisabledGA4Button() {
      return (
        this.$store.state.user.me.isEmployee ||
        this.$store.state.user.me.isSwAdmin
      );
    },
    isVisibleGA4Button() {
      return (
        !this.$constants.isDemo && !this.isLoading && !this.project.ga4AccountId
      );
    }
  },
  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    params: {
      handler() {
        // 何か入力したらサーバーからのエラーメッセージを消す
        this.errorResponse = '';
      },
      deep: true
    },
    'params.projectName': {
      handler() {
        this.validate();
      },
      immediate: true
    },
    project: {
      handler() {
        this.params.projectName = this.project.name;
        this.validate();
      }
    }
  },
  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },
    submit() {
      if (this.isError || this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      let params = {
        name: this.params.projectName
      };

      apiProjects
        .put(params, this.auth.idToken, this.project.id)
        .then(response => {
          this.isProcessing = false;
          // サイト一覧を再取得して更新する
          this.$store.dispatch('user/getProjects');
        })
        .catch(error => {
          if (error.response) {
            this.errorResponse = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;
        });
    },
    validate() {
      let name = this.params.projectName.trim();
      this.error.projectName = new Validation().input().test(name);
      this.isEdited.projectName = name !== this.project.name ? true : false;
    }
  }
};
</script>
